// eslint-disable-next-line import/prefer-default-export
export const getDate = (): Date => new Date();

export const getTodaysTimestampInUTCMS = (): number => getDate().getTime();
